<template>
  <button
    class="ms-button btn"
    :class="[
      type,
      text ? '' : 'only-icon',
      radius ? 'btn-radius' : '',
      hasBorder ? '' : 'btn-border-none',
      disabled ? 'disabled-icon' : '',
    ]"
    :disabled="disabled || processing"
    v-tooltip="title"
    :type="submitButton?'submit':'button'"
  >
    <div
      :class="['icon left', leftIcon, disabled ? 'disabled-icon' : '']"
      v-if="leftIcon"
    >
      &nbsp;
    </div>
    <div  
      class="text"
      :class="[{ 'pr-0 pl-0': leftIcon, 'pl-0': rightIcon }]"
      v-if="text"
    >
      {{ text }}
    </div>
    <div
      :class="['icon right', rightIcon, disabled ? 'disabled-icon' : '']"
      v-if="rightIcon"
    ></div>

    <div
      v-if="$slots.default"
      class="ms-button-text ms-button--text flex align-center justify-center"
    >
      <slot />
    </div>
  </button>
</template>
<script>
import { defineComponent, computed } from 'vue';

export default defineComponent({
  name: 'msButton',
  props: {
    //Text hiển thị
    title: {
      defualt: null,
      type: String,
    },
    //Text hiển thị
    text: {
      defualt: null,
      type: String,
    },
    //Icon trái
    leftIcon: {
      default: null,
      type: String,
    },
    //Icon phải
    rightIcon: {
      default: null,
      type: String,
    },
    //Loại button gồm 3 loại primary/secondary/third/four để hiện thị style tương ứng
    type: {
      default: 'primary',
      type: String,
    },
    /**
     * Trạng thái button disabled
     */
    disabled: {
      default: false,
      type: Boolean,
    },
    /**
     * Cờ đánh dấu đang xử lý
     */
    processing: {
      default: false,
      type: Boolean,
    },
    radius: {
      default: false,
      type: Boolean,
    },
    //border hiển thị
    hasBorder: {
      default: false,
      type: Boolean,
    },
    // type submit
    submitButton: {
      default: false,
      type: Boolean
    }
  },
  setup(props, { emit }) {
    /**
     * Hủy lan rộng event
     * HTHIEP 09.02.2022
     */
    const cancelEvent = (e) => {
      if (e) {
        if (typeof e.preventDefault === 'function') {
          e.preventDefault();
        }

        if (typeof e.stopPropagation === 'function') {
          e.stopPropagation();
        }

        if (typeof e.stopImmediatePropagation === 'function') {
          e.stopImmediatePropagation();
        }
      }
    };

    /**
     * Xử lý thò các event ra ngoài component
     * HTHIEP 09.02.2022
     */
    const listeners = computed(() => {
      const me = this;
      return {
        click: (event) => {
          //hủy lan rộng event
          cancelEvent(event);

          let deplay = window._appConfig.buttonClickDeplayMilliseconds;
          if (deplay && deplay > 0) {
            if (me._clicking) {
              return;
            }

            me._clicking = true;
            setTimeout(() => {
              delete me._clicking;
            }, deplay);
          }
          // me.$emit("click", event);
        },
        mousedown: (event) => {
          //hủy lan rộng event
          cancelEvent(event);
        },
        keydown: (event) => {
          //hủy lan rộng event
          cancelEvent(event);

          //trigger ra ngoài component
          emit('keydown', event);
        },
        focus: (event) => {
          //hủy lan rộng event
          cancelEvent(event);

          //trigger ra ngoài component
          emit('focus', event);
        },
      };
    });

    return { listeners };
  },
});
</script>
<style scoped lang="scss">
@import '@/assets/scss/components/MsButton.scss';
</style>
